import { ErrorBase } from './error.base';

export class ErrorTimeout extends ErrorBase {

    constructor() {
        super('Timeout', 'Es konnte keine Verbindung zum Server aufgebaut werden.')
    }

}
